import { RESET_SUNPAL_CONFIG_FORM } from '../actionTypes';
import { actions } from '../reducer';

export default () => actions[RESET_SUNPAL_CONFIG_FORM]();
